import React from 'react';
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from '@mui/material';

const VersionSelector = ({
  versions = [],
  selectedVersion,
  loading = false,
  onVersionChange,
  onMakeVersionActive,
  onExecuteVersion
}) => {
  if (!versions || versions.length === 0) {
    return (
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          {loading ? (
            <CircularProgress size={20} />
          ) : (
            <span>No versions available</span>
          )}
        </Grid>
      </Grid>
    );
  }

  const isSelectedVersionActive = selectedVersion ? 
    versions.find(v => v.versionNumber === selectedVersion)?.isActive : 
    false;

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item>
        {loading ? (
          <CircularProgress size={20} style={{ marginRight: 8 }} />
        ) : null}
        <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
          <Select
            labelId="version-select-label"
            value={selectedVersion || ''}
            onChange={(event) => onVersionChange(event.target.value)}
            disabled={loading}
          >
            {versions.map((version) => (
              <MenuItem key={version.versionNumber} value={version.versionNumber}>
                Version {version.versionNumber} {version.isActive ? "(Active)" : ""}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item style={{ display: 'flex', gap: '8px' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onMakeVersionActive}
          disabled={loading || isSelectedVersionActive}
          size="small"
        >
          Set Active
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onExecuteVersion}
          disabled={loading}
          size="small"
        >
          Execute Version
        </Button>
      </Grid>
    </Grid>
  );
};

export default VersionSelector;